import React from 'react';
import { Page, withServerErrors } from 'components/common';
import { FormGroup, SaveButton, BackButton } from 'components/common/Forms';
import { compose, withState, withHandlers } from 'recompose';
import { LocalForm, Fieldset, Control } from 'react-redux-form';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import withLifecycle from '@hocs/with-lifecycle';

import {
  WhiteLabelPartners,
  Orders,
  Pricing,
  SLA,
  DeviceTypes,
  InstallationTypes,
  Issuers
} from '.';

const passwordsMatch = ({ password, confirmPassword }) =>
  password === confirmPassword;

const tabs = [
  'White Label Partner',
  'Pricing',
  // 'Create Order',
  'SLA',
  'Device Types',
  'Installation Types',
  'Issuers'
];

export const Admin = ({
  mode,
  url,
  client,
  onBack,
  activeTab,
  toggleTab,
  renderServerError,
  readOnly,
  history,
}) => {

  return (
    <Page title='Admin'>
      <Nav pills>
        {tabs.map((t, i) => (
          <NavItem key={i}>
            <NavLink
              className={classnames({ active: activeTab === i })}
              onClick={e => toggleTab(e, i)}
              href="#"
            >
              {t}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      <TabContent activeTab={activeTab}>
        {/* <TabPane tabId={tabs.indexOf('Create Order')}>
          <Orders.Create 
            history={history}
            client={client}
          />
        </TabPane> */}
        <TabPane tabId={tabs.indexOf('White Label Partner')}>
          <WhiteLabelPartners.List
            client={client}
          />
        </TabPane>
        <TabPane tabId={tabs.indexOf('Pricing')}>
          <Pricing
            client={client}
          />
        </TabPane>
        <TabPane tabId={tabs.indexOf('SLA')}>
          <SLA
            client={client}
          />
        </TabPane>
        <TabPane tabId={tabs.indexOf('Device Types')}>
          <DeviceTypes
            client={client}
          />
        </TabPane>
        <TabPane tabId={tabs.indexOf('Installation Types')}>
          <InstallationTypes
            client={client}
          />
        </TabPane>
        <TabPane tabId={tabs.indexOf('Issuers')}>
          <Issuers
            client={client}
          />
        </TabPane>
      </TabContent>
    </Page>
  )
};

const enhance = compose(
  withServerErrors(),
  withState('activeTab', 'setActiveTab', tabs.indexOf('White Label Partner')),
  withState('serverErrors', 'setServerErrors', {}),
  withHandlers({
    onFileDrop: ({ setLogo }) => accepted => {
      setLogo(accepted[0]);
    },
    toggleTab: ({ setActiveTab }) => (event, tab) => {
      event.preventDefault();
      setActiveTab(tab);
    },
  }),
  withLifecycle({
    onDidMount: ({ setActiveTab }) => {
      const index = tabs.indexOf(
        decodeURIComponent(window.location.hash.replace('#', ''))
      );
      index >= 0 && setActiveTab(index);
    },
  })
);

export default enhance(Admin);



// WEBPACK FOOTER //
// ./src/pages/Admin.jsx